// Central config for generic CRUD resources + navigation.
const STAFF = ["direction", "administration", "coordinateur", "finance"];
const ADMIN = ["direction", "administration"];
const ACAD_W = ["direction", "administration", "coordinateur"];
const PED_ROLES = ["super_admin", "direction", "administration", "coordinateur", "professeur"];
const PED_SUP = ["super_admin", "direction", "administration", "coordinateur"];
const TEACH_W = ["professeur", "coordinateur", "direction", "administration"];

export const RESOURCES = {
  students: {
    endpoint: "/students", titleKey: "students", write: ADMIN,
    columns: [
      { key: "name", labelKey: "name" },
      { key: "level_name", labelKey: "level" },
      { key: "family_name", labelKey: "family" },
      { key: "status", labelKey: "status", badge: true },
    ],
    fields: [
      { name: "name", labelKey: "name", type: "text", required: true },
      { name: "birthdate", labelKey: "birthdate", type: "date" },
      { name: "family_id", labelKey: "family", type: "select", source: "families", optionLabel: "name" },
      { name: "level_id", labelKey: "level", type: "select", source: "levels", optionLabel: "name" },
      { name: "status", labelKey: "status", type: "enum", options: ["active", "inactive"] },
    ],
  },
  families: {
    endpoint: "/families", titleKey: "families", write: ADMIN,
    columns: [{ key: "name", labelKey: "name" }, { key: "email", labelKey: "email" }, { key: "phone", labelKey: "phone" }],
    fields: [
      { name: "name", labelKey: "name", type: "text", required: true },
      { name: "email", labelKey: "email", type: "text" },
      { name: "phone", labelKey: "phone", type: "text" },
      { name: "address", labelKey: "address", type: "text" },
    ],
  },
  parents: {
    endpoint: "/parents", titleKey: "parents", write: ADMIN,
    columns: [{ key: "name", labelKey: "name" }, { key: "email", labelKey: "email" }, { key: "phone", labelKey: "phone" }],
    fields: [
      { name: "name", labelKey: "name", type: "text", required: true },
      { name: "email", labelKey: "email", type: "text" },
      { name: "phone", labelKey: "phone", type: "text" },
      { name: "family_id", labelKey: "family", type: "select", source: "families", optionLabel: "name" },
    ],
  },
  teachers: {
    endpoint: "/teachers", titleKey: "teachers", write: ADMIN,
    columns: [{ key: "name", labelKey: "name" }, { key: "email", labelKey: "email" }, { key: "phone", labelKey: "phone" }],
    fields: [
      { name: "name", labelKey: "name", type: "text", required: true },
      { name: "email", labelKey: "email", type: "text" },
      { name: "phone", labelKey: "phone", type: "text" },
    ],
  },
  "school-years": {
    endpoint: "/school-years", titleKey: "schoolYears", write: ACAD_W,
    columns: [{ key: "name", labelKey: "name" }, { key: "start_date", labelKey: "date" }, { key: "end_date", labelKey: "dueDate" }],
    fields: [
      { name: "name", labelKey: "name", type: "text", required: true },
      { name: "start_date", labelKey: "date", type: "date" },
      { name: "end_date", labelKey: "dueDate", type: "date" },
    ],
  },
  levels: {
    endpoint: "/levels", titleKey: "levels", write: ACAD_W,
    columns: [{ key: "name", labelKey: "name" }],
    fields: [
      { name: "name", labelKey: "name", type: "text", required: true },
      { name: "school_year_id", labelKey: "schoolYears", type: "select", source: "school-years", optionLabel: "name" },
    ],
  },
  subjects: {
    endpoint: "/subjects", titleKey: "subjects", write: ACAD_W,
    columns: [{ key: "name", labelKey: "name" }, { key: "code", labelKey: "number" }],
    fields: [
      { name: "name", labelKey: "name", type: "text", required: true },
      { name: "code", labelKey: "number", type: "text" },
      { name: "color", labelKey: "name", type: "text" },
    ],
  },
  groups: {
    endpoint: "/groups", titleKey: "groups", write: ACAD_W,
    columns: [{ key: "name", labelKey: "name" }],
    fields: [
      { name: "name", labelKey: "name", type: "text", required: true },
      { name: "level_id", labelKey: "level", type: "select", source: "levels", optionLabel: "name" },
    ],
  },
  enrollments: {
    endpoint: "/enrollments", titleKey: "enrollments", write: ADMIN,
    columns: [{ key: "status", labelKey: "status", badge: true }, { key: "date", labelKey: "date" }],
    fields: [
      { name: "student_id", labelKey: "student", type: "select", source: "students", optionLabel: "name" },
      { name: "group_id", labelKey: "group", type: "select", source: "groups", optionLabel: "name" },
      { name: "status", labelKey: "status", type: "enum", options: ["pending", "confirmed", "cancelled"] },
      { name: "date", labelKey: "date", type: "date" },
    ],
  },
  homework: {
    endpoint: "/homework", titleKey: "homework", write: TEACH_W,
    columns: [{ key: "title", labelKey: "title" }, { key: "due_date", labelKey: "dueDate" }],
    fields: [
      { name: "title", labelKey: "title", type: "text", required: true },
      { name: "description", labelKey: "description", type: "textarea" },
      { name: "group_id", labelKey: "group", type: "select", source: "groups", optionLabel: "name" },
      { name: "subject_id", labelKey: "subject", type: "select", source: "subjects", optionLabel: "name" },
      { name: "due_date", labelKey: "dueDate", type: "date" },
    ],
  },
  grades: {
    endpoint: "/grades", titleKey: "grades", write: TEACH_W,
    columns: [
      { key: "student_name", labelKey: "student" },
      { key: "subject_name", labelKey: "subject" },
      { key: "value", labelKey: "value" },
      { key: "max", labelKey: "max" },
      { key: "term", labelKey: "term" },
    ],
    fields: [
      { name: "student_id", labelKey: "student", type: "select", source: "students", optionLabel: "name" },
      { name: "subject_id", labelKey: "subject", type: "select", source: "subjects", optionLabel: "name" },
      { name: "value", labelKey: "value", type: "number", required: true },
      { name: "max", labelKey: "max", type: "number" },
      { name: "term", labelKey: "term", type: "text" },
      { name: "comment", labelKey: "comment", type: "text" },
    ],
  },
  attendance: {
    endpoint: "/attendance", titleKey: "attendance", write: TEACH_W,
    columns: [
      { key: "student_name", labelKey: "student" },
      { key: "date", labelKey: "date" },
      { key: "status", labelKey: "status", badge: true },
    ],
    fields: [
      { name: "student_id", labelKey: "student", type: "select", source: "students", optionLabel: "name" },
      { name: "date", labelKey: "date", type: "date" },
      { name: "status", labelKey: "status", type: "enum", options: ["present", "absent", "late"] },
    ],
  },
  documents: {
    endpoint: "/documents", titleKey: "documents", write: [...STAFF, "professeur"],
    columns: [{ key: "name", labelKey: "name" }, { key: "category", labelKey: "subject" }, { key: "uploaded_by", labelKey: "teacher" }],
    fields: [
      { name: "name", labelKey: "name", type: "text", required: true },
      { name: "category", labelKey: "subject", type: "text" },
      { name: "url", labelKey: "description", type: "text" },
      { name: "visibility", labelKey: "status", type: "enum", options: ["staff", "public"] },
    ],
  },
  "action-plans": {
    endpoint: "/action-plans", titleKey: "actionPlans", write: TEACH_W,
    columns: [{ key: "title", labelKey: "title" }, { key: "student_name", labelKey: "student" }, { key: "status", labelKey: "status", badge: true }],
    fields: [
      { name: "title", labelKey: "title", type: "text", required: true },
      { name: "student_id", labelKey: "student", type: "select", source: "students", optionLabel: "name" },
      { name: "objectives", labelKey: "description", type: "textarea" },
      { name: "status", labelKey: "status", type: "enum", options: ["open", "in_progress", "closed"] },
    ],
  },
  "sensitive-cases": {
    endpoint: "/sensitive-cases", titleKey: "sensitiveCases", write: ["direction", "coordinateur"], readRoles: ["direction", "coordinateur"],
    columns: [{ key: "title", labelKey: "title" }, { key: "created_by", labelKey: "teacher" }],
    fields: [
      { name: "title", labelKey: "title", type: "text", required: true },
      { name: "student_id", labelKey: "student", type: "select", source: "students", optionLabel: "name" },
      { name: "notes", labelKey: "description", type: "textarea" },
    ],
  },
  receipts: {
    endpoint: "/finance/receipts", titleKey: "receipts", write: [], readonly: true, pdf: "/finance/receipts",
    columns: [
      { key: "number", labelKey: "number" },
      { key: "family_name", labelKey: "family" },
      { key: "amount", labelKey: "amount" },
      { key: "method", labelKey: "method" },
      { key: "date", labelKey: "date" },
    ],
  },
  "audit-logs": {
    endpoint: "/audit-logs", titleKey: "auditLogs", write: [], readonly: true, readRoles: ["super_admin", "direction"],
    columns: [
      { key: "created_at", labelKey: "date" },
      { key: "user_name", labelKey: "name" },
      { key: "action", labelKey: "actions" },
      { key: "entity", labelKey: "subject" },
      { key: "detail", labelKey: "description" },
    ],
  },
};

const ALL = ["super_admin", "direction", "administration", "finance", "coordinateur", "professeur", "parent", "eleve"];

export const NAV = [
  { items: [{ to: "/dashboard", labelKey: "dashboard", icon: "LayoutDashboard", roles: ALL }, { to: "/profile", labelKey: "profile", icon: "User", roles: ALL }] },
  {
    labelKey: "pedagogy", items: [
      { to: "/pedagogy/my-sessions", labelKey: "mySessions", icon: "CalendarClock", roles: PED_ROLES },
      { to: "/pedagogy/cahier", labelKey: "sessionNotebook", icon: "ClipboardList", roles: PED_ROLES },
      { to: "/pedagogy/attendance", labelKey: "attendance", icon: "CalendarCheck", roles: PED_ROLES },
      { to: "/pedagogy/homework", labelKey: "homework", icon: "BookOpen", roles: PED_ROLES },
      { to: "/pedagogy/grades", labelKey: "grades", icon: "GraduationCap", roles: PED_ROLES },
      { to: "/pedagogy/supervision", labelKey: "pedagogySupervision", icon: "Target", roles: PED_SUP },
    ],
  },
  {
    labelKey: "scolarite", items: [
      { to: "/admin/admissions", labelKey: "admissions", icon: "FileCheck", roles: ["super_admin", "direction", "administration", "coordinateur", "finance"] },
      { to: "/admin/school-calendar", labelKey: "schoolCalendar", icon: "CalendarDays", roles: ["super_admin", "direction", "administration"] },
      { to: "/admin/requirements", labelKey: "requiredDocsConfig", icon: "ListChecks", roles: ["super_admin", "direction", "administration"] },
    ],
  },
  {
    labelKey: "documents", items: [
      { to: "/documents", labelKey: "documentRegistry", icon: "FolderOpen", roles: ["super_admin", "direction", "administration", "coordinateur", "finance"] },
      { to: "/documents/templates", labelKey: "pdfTemplates", icon: "FileText", roles: ["super_admin", "direction", "administration"] },
      { to: "/documents/logs", labelKey: "documentLogs", icon: "ScrollText", roles: ["super_admin", "direction"] },
    ],
  },
  {
    labelKey: "people", items: [
      { to: "/people/families", labelKey: "families", icon: "Home", roles: [...STAFF, "parent"] },
      { to: "/people/parents", labelKey: "parents", icon: "UserCog", roles: STAFF },
      { to: "/people/students", labelKey: "students", icon: "IdCard", roles: [...STAFF, "professeur"] },
      { to: "/people/teachers", labelKey: "teachers", icon: "Presentation", roles: STAFF },
      { to: "/people/cards", labelKey: "studentCards", icon: "CreditCard", roles: STAFF },
      { to: "/people/cards/print", labelKey: "cardPrintMenu", icon: "Printer", roles: STAFF },
      { to: "/people/scan", labelKey: "scanMenu", icon: "ScanLine", roles: ["super_admin", "direction", "administration"] },
    ],
  },
  {
    labelKey: "schoolOrg", items: [
      { to: "/school", labelKey: "schoolDashboard", icon: "LayoutPanelTop", roles: [...STAFF] },
      { to: "/school/levels", labelKey: "officialLevels", icon: "Layers3", roles: [...STAFF, "professeur"] },
      { to: "/school/groups", labelKey: "internalGroups", icon: "Boxes", roles: [...STAFF, "professeur"] },
      { to: "/school/teacher-assignments", labelKey: "teacherAssignments", icon: "UserCog", roles: [...STAFF] },
      { to: "/school/periods", labelKey: "periods", icon: "CalendarRange", roles: [...STAFF] },
      { to: "/school/rooms", labelKey: "rooms", icon: "DoorOpen", roles: [...STAFF] },
      { to: "/school/timetable", labelKey: "timetable", icon: "CalendarClock", roles: [...STAFF, "professeur"] },
      { to: "/school-years", labelKey: "schoolYears", icon: "CalendarRange", roles: [...STAFF, "professeur"] },
      { to: "/subjects", labelKey: "subjects", icon: "Library", roles: [...STAFF, "professeur"] },
    ],
  },
  {
    labelKey: "finance", items: [
      { to: "/finance/dashboard", labelKey: "financeDashboard", icon: "LayoutDashboard", roles: ["super_admin", "direction", "administration", "finance"] },
      { to: "/finance/invoices", labelKey: "invoices", icon: "Receipt", roles: ["super_admin", "direction", "administration", "finance"] },
      { to: "/finance/monthly-batch", labelKey: "monthlyBatch", icon: "CalendarRange", roles: ["super_admin", "direction", "administration", "finance"] },
      { to: "/finance/payments", labelKey: "payments", icon: "CreditCard", roles: ["super_admin", "direction", "administration", "finance"] },
      { to: "/finance/receipts", labelKey: "receipts", icon: "FileCheck", roles: ["super_admin", "direction", "administration", "finance"] },
      { to: "/finance/accounts", labelKey: "financeAccounts", icon: "Wallet", roles: ["super_admin", "direction", "administration", "finance"] },
      { to: "/finance/cash-accounts", labelKey: "cashAccounts", icon: "Landmark", roles: ["super_admin", "direction", "administration", "finance"] },
      { to: "/finance/expenses", labelKey: "expenses", icon: "TrendingDown", roles: ["super_admin", "direction", "administration", "finance"] },
      { to: "/finance/fee-grids", labelKey: "feeGrids", icon: "Table2", roles: ["super_admin", "direction", "administration", "finance"] },
    ],
  },
  {
    labelKey: "settingsSecurity", items: [
      { to: "/users", labelKey: "users", icon: "UserPlus", roles: ["direction", "administration"] },
      { to: "/admin/security", labelKey: "securityCenter", icon: "ShieldCheck", roles: ["super_admin", "direction"] },
      { to: "/settings", labelKey: "settings", icon: "Settings", roles: ["super_admin", "direction", "administration"] },
      { to: "/audit", labelKey: "auditRegister", icon: "ScrollText", roles: ["super_admin", "direction"] },
    ],
  },
];
